export const GET_GIFT_OPTIONS_SUCCESS = 'GET_GIFT_OPTIONS_SUCCESS';
export const REQUEST_GIFT_OPTIONS = 'REQUEST_GIFT_OPTIONS';
